/* eslint-disable indent */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable quotes */
/* eslint-disable camelcase */
// ── DATA ──────────────────────────────────────────────────────────────────

const decisionRules = [
  { conditions: { age: '3-5' }, outcome_id: 'stage_1_foundation' },
  {
    conditions: { age: '5-7', reading_level: 'blending_struggles' },
    outcome_id: 'stage_2_phonics_focus',
  },
  {
    conditions: { age: '5-7', reading_level: 'fluent', writing_level: 'spelling_struggles' },
    outcome_id: 'stage_3_spelling_focus',
  },
  { conditions: { age: '5-7' }, outcome_id: 'stage_2_general' },
  {
    conditions: { age: '7-9', reading_level: 'blending_struggles' },
    outcome_id: 'stage_2_phonics_focus',
  },
  {
    conditions: { age: '7-9', writing_level: 'spelling_struggles' },
    outcome_id: 'stage_3_spelling_focus',
  },
  { conditions: { age: '7-9' }, outcome_id: 'stage_4_general' },
  {
    conditions: { age: '9-12', writing_level: 'spelling_struggles' },
    outcome_id: 'stage_3_spelling_focus',
  },
  { conditions: { age: '9-12' }, outcome_id: 'stage_5_general' },
  { conditions: { age: '12+' }, outcome_id: 'stage_6_general' },
];

// ── STATE ─────────────────────────────────────────────────────────────────
let currentStep = 0;
let userState = {};
let selectedAnswers = [];
let chargedLayerIds = []; // set by the multi-select skills question
let currentOutcomeId = ''; // resolved once the quiz is finished
let userEmail = ''; // captured at the email gate, reused by the save-path button

// Skills available per age group (layer indices 0-5, l7 is the goal not a skill to tick)
const skillsByAge = {
  '3-5': [0], // only Phonics is plausible to have started
  '5-7': [0, 1], // Phonics + Vocab
  '7-9': [0, 1, 2, 3], // up to Storytelling
  '9-12': [0, 1, 2, 3, 4], // up to Digital
  '12+': [0, 1, 2, 3, 4, 5], // all 6 skill layers
};

// ── INIT ──────────────────────────────────────────────────────────────────
// The hero doubles as the welcome screen, so this drops straight into question 1.
function startQuiz() {
  document.getElementById('hero').style.display = 'none';
  showQuestion(0);
}

function showQuestion(index) {
  document.getElementById('quiz-screen').classList.add('active');

  currentStep = index;
  renderStepIndicator();
  renderQuestion();
  updateProgressBar();
}

function renderStepIndicator() {
  const ind = document.getElementById('step-indicator');
  ind.innerHTML = '';
  for (let i = 0; i < questions.length; i++) {
    const dot = document.createElement('div');
    dot.className = 'step-dot';
    if (i < currentStep) dot.classList.add('done');
    if (i === currentStep) dot.classList.add('active');
    ind.appendChild(dot);
  }
}

function renderQuestion() {
  const q = questions[currentStep];
  const area = document.getElementById('question-area');

  // ── MULTI-SELECT SKILLS STEP ──
  if (q.type === 'Multiple choice') {
    const age = userState.age || '3-5';
    const availableIndices = skillsByAge[age] || [0];
    let tilesHtml = '';
    availableIndices.forEach((idx) => {
      const l = layers[idx];
      const isSelected = chargedLayerIds.includes(idx);
      tilesHtml += `
            <button class="skill-tile ${
              isSelected ? 'selected' : ''
            }" onclick="toggleSkill(${idx})">
              <span class="skill-tile-dot" style="background:${l.color}"></span>
              <span>${l.icon} ${l.name}</span>
              <span class="skill-tile-check">✓</span>
            </button>
          `;
    });
    const noneSelected = chargedLayerIds.length === 0;
    area.innerHTML = `
          <div class="question-card">
            <div class="question-label">Question ${currentStep + 1} of ${questions.length}</div>
            <div class="question-text">${q.text}</div>
            <p style="font-size:1.4rem;color:#888;margin-bottom:20px;">${q.hint}</p>
            <div class="skills-grid">${tilesHtml}</div>
            <button class="none-yet-btn ${
              noneSelected ? 'selected' : ''
            }" onclick="selectNoneYet()">None of these yet — we are just starting out</button>
          </div>
        `;
    // multi-select is always valid (zero selections = just starting)
    document.getElementById('next-btn').classList.add('enabled');
    return;
  }

  // ── STANDARD SINGLE-SELECT ──
  let html = `
        <div class="question-card">
          <div class="question-label">Question ${currentStep + 1} of ${questions.length}</div>
          <div class="question-text">${q.text}</div>
          <div class="answers">
      `;

  q.answers.forEach((ans, i) => {
    const isSelected = selectedAnswers[currentStep] === i;
    html += `
          <button class="answer-btn ${isSelected ? 'selected' : ''}" onclick="selectAnswer(${i}, '${
      ans.value
    }')">
            <span class="answer-emoji">${ans.emoji}</span>
            ${ans.text}
          </button>
        `;
  });

  html += '</div></div>';
  area.innerHTML = html;

  const nextBtn = document.getElementById('next-btn');
  if (selectedAnswers[currentStep] !== undefined) {
    nextBtn.classList.add('enabled');
  } else {
    nextBtn.classList.remove('enabled');
  }
}

function selectAnswer(ansIndex, value) {
  selectedAnswers[currentStep] = ansIndex;
  userState[questions[currentStep].stateKey] = value;

  // Toggle .selected on answer buttons directly without re-rendering the whole card
  const area = document.getElementById('question-area');
  const buttons = area.querySelectorAll('.answer-btn');
  buttons.forEach((btn, i) => {
    btn.classList.toggle('selected', i === ansIndex);
  });

  document.getElementById('next-btn').classList.add('enabled');
}

function toggleSkill(layerIndex) {
  const pos = chargedLayerIds.indexOf(layerIndex);
  if (pos === -1) {
    chargedLayerIds.push(layerIndex);
  } else {
    chargedLayerIds.splice(pos, 1);
  }
  userState.charged_layers = [...chargedLayerIds];

  // Directly update tile classes in the DOM
  const area = document.getElementById('question-area');
  const age = userState.age || '3-5';
  const availableIndices = skillsByAge[age] || [0];
  const tiles = area.querySelectorAll('.skill-tile');

  availableIndices.forEach((idx, i) => {
    if (tiles[i]) {
      tiles[i].classList.toggle('selected', chargedLayerIds.includes(idx));
    }
  });

  const noneBtn = area.querySelector('.none-yet-btn');
  if (noneBtn) {
    noneBtn.classList.toggle('selected', chargedLayerIds.length === 0);
  }
}

function selectNoneYet() {
  chargedLayerIds = [];
  userState.charged_layers = [];

  // Directly clear tiles and select "None yet" button
  const area = document.getElementById('question-area');
  const tiles = area.querySelectorAll('.skill-tile');
  tiles.forEach((tile) => tile.classList.remove('selected'));

  const noneBtn = area.querySelector('.none-yet-btn');
  if (noneBtn) {
    noneBtn.classList.add('selected');
  }
}

function nextStep() {
  if (currentStep < questions.length - 1) {
    showQuestion(currentStep + 1);
  } else {
    showResults();
  }
}

function updateProgressBar() {
  const pct = (currentStep / questions.length) * 100;
  document.getElementById('progress-bar').style.width = pct + '%';
}

// Resolve the outcome from the decision matrix. Shared by the email gate and the results render.
function resolveOutcomeId() {
  for (const rule of decisionRules) {
    let match = true;
    for (const [key, val] of Object.entries(rule.conditions)) {
      if (userState[key] !== val) {
        match = false;
        break;
      }
    }
    if (match) return rule.outcome_id;
  }
  return 'stage_1_foundation'; // fallback
}

function showResults() {
  document.getElementById('quiz-screen').classList.remove('active');
  const page = document.getElementById('results-page');

  currentOutcomeId = resolveOutcomeId();

  const res = results[currentOutcomeId];
  const pbHtml = renderPowerbank(res.chargingLayerId);
  const prodHtml = renderProducts(res.products);
  const bundleHtml = renderBundle(res);
  const researchHtml = renderResearch(res);
  const nextHtml = renderNextLayer(res);
  const emailHtml = renderEmailCapture();

  page.innerHTML = `
        <div class="results-header">
          <div class="stage-badge">${res.stage}</div>
          <h2>${res.headline}</h2>
          <p>${res.body}</p>
        </div>
        <div class="results-body">
          <div class="results-aside">${pbHtml}</div>
          <div class="results-main">
            ${prodHtml}
            ${bundleHtml}
            ${emailHtml}
            ${researchHtml}
            ${nextHtml}
          </div>
        </div>
      `;

  page.classList.add('active');
}

function renderPowerbank(chargingIndex) {
  // ROUTING ALWAYS WINS: chargingIndex is set by the decision matrix (Q1+Q3+Q4+Q5 only).
  // Q2 (chargedLayerIds) never overrides it — a powerbank fills bottom-up, so everything
  // below the charging layer reads as charged and everything above it as upcoming.

  const layerName = layers.find((l) => l.id === chargingIndex).name;

  const layerIndex = layers.findIndex((l) => l.id === chargingIndex);

  let html = `
        <div class="powerbank-section">
          <h3>The Literacy Powerbank</h3>
          <div class="powerbank-title">Your child is currently charging <span>${layerName}</span></div>
          <div class="powerbank-layers">
      `;

  // Reverse so the top layer renders first
  [...layers].reverse().forEach((l, i) => {
    const actualIndex = layers.length - 1 - i;
    let stateClass = 'upcoming';
    let statusHtml = '';

    if (actualIndex === layerIndex) {
      // Routing result always takes priority — this is always the active charging layer
      stateClass = 'charging';
      statusHtml = `<span class="charging-label">⚡ Charging Now</span>`;
    } else if (actualIndex < layerIndex) {
      // Everything beneath the charging layer is already charged. Ticks from Q2 never mark a
      // layer above the charging one, which used to produce "L2 charged, L1 charging".
      stateClass = 'charged';
      statusHtml = `<span class="pb-layer-status">✓ Charged</span>`;
    }
    // else: upcoming — vivid colour, no badge

    // Badge sits on the ages line so it never competes with the layer name for width —
    // the row has to survive a ~360px sidebar as well as full-width mobile.
    html += `
          <div class="pb-layer ${stateClass}" style="background-color: ${l.color}">
            <div class="pb-layer-info">
              <div class="pb-layer-name">${l.name}</div>
              <div class="pb-layer-meta">
                <span class="pb-layer-ages">${l.ages}</span>
                ${statusHtml}
              </div>
            </div>
            <div class="pb-layer-icon">${l.icon}</div>
          </div>
        `;
  });

  html += `</div></div>`;
  return html;
}

function renderProducts(prods) {
  let html = `
        <div class="products-section">
          <div class="section-title">Charge this layer now</div>
          <div class="section-subtitle">These 3 resources will build the exact skills your child needs next.</div>
          <div class="products-grid">
      `;
  prods.forEach((p) => {
    html += `
          <div class="product-card">
            <div class="product-card-img">
              <img src="${p.image}" loading="lazy" />
            </div>
            <div class="product-card-body">
              <div class="product-card-name">${p.name}</div>
              ${p.price ? `<div class="product-card-price">${p.price}</div>` : ''}
              ${p.tagline ? `<div class="product-card-tagline">${p.tagline}</div>` : ''}
              <a href="${p.url}" class="product-card-btn ajax_cart" data-variant_id="${
      p.variantId
    }">Add to Cart ➔</a>
            </div>
          </div>
        `;
  });
  html += '</div></div>';
  return html;
}

// ── BUNDLE ────────────────────────────────────────────────────────────────
function bundleItems(res) {
  return (res.products || []).filter((p) => p.variantId);
}

function renderBundle(res) {
  if (!quizSettings.bundleEnabled) return '';

  const items = bundleItems(res);
  // A "bundle" of one is just the product card again
  if (items.length < 2) return '';

  const discount = quizSettings.bundleDiscountPercent;
  const thumbs = items
    .map((p) => `<div class="bundle-thumb"><img src="${p.image}" alt="" loading="lazy" /></div>`)
    .join('<span class="bundle-plus">+</span>');

  const lines = items
    .map((p) => `<li><span>${p.name}</span><span>${p.price || ''}</span></li>`)
    .join('');

  return `
        <div class="bundle-section">
          ${discount > 0 ? `<div class="bundle-badge">Save ${discount}%</div>` : ''}
          <div class="bundle-title">${quizSettings.bundleTitle}</div>
          <div class="bundle-subtitle">${quizSettings.bundleSubtitle}</div>
          <div class="bundle-thumbs">${thumbs}</div>
          <ul class="bundle-list">${lines}</ul>
          <div class="bundle-pricing">
            ${discount > 0 ? `<span class="bundle-compare">${res.bundle.total}</span>` : ''}
            <span class="bundle-price">${res.bundle.price}</span>
            ${
              discount > 0
                ? `<span class="bundle-savings">You save ${res.bundle.savings}</span>`
                : ''
            }
          </div>
          <button class="bundle-btn" id="bundle-btn" onclick="addBundleToCart()">${
            quizSettings.bundleButtonLabel
          }</button>
          <div class="bundle-note" id="bundle-note"></div>
        </div>
      `;
}

function addBundleToCart() {
  const btn = document.getElementById('bundle-btn');
  const note = document.getElementById('bundle-note');
  if (!btn || btn.disabled) return;

  const res = results[currentOutcomeId];
  const bundleProducts = bundleItems(res);
  const items = bundleProducts.map((p) => ({
    id: p.variantId,
    quantity: 1,
  }));
  if (!items.length) return;

  const code = (quizSettings.bundleDiscountCode || '').trim();
  const bundleTracking = {
    bundle: true,
    bundle_discount_percent: quizSettings.bundleDiscountPercent,
    discount_code: code,
    // The discounted price is what they'll actually pay, so that's the value.
    $value: toAmount(res.bundle && res.bundle.priceCents),
  };

  // ── DISCOUNTED BUNDLE: straight to checkout via a cart permalink ──
  // One hop, discount already applied. No /cart/add.js call, so Shopify's own
  // add-to-cart pixel never fires for a bundle — this event is the only record of it.
  if (code) {
    btn.disabled = true;
    btn.innerText = 'Taking you to checkout…';

    const payload = addToCartPayload(bundleProducts, bundleTracking);
    const checkoutUrl = bundlePermalinkUrl(bundleProducts, code);

    if (klaviyoBeacon('Added Quiz Bundle to Cart', payload, userEmail, payload.$value)) {
      window.location.href = checkoutUrl;
      return;
    }

    // No company ID or no email to attach — fall back to the onsite call and give it a
    // moment to leave the page, since navigating mid-request drops it.
    settleWithin(klaviyoTrack('Added Quiz Bundle to Cart', payload), 800).then(() => {
      window.location.href = checkoutUrl;
    });
    return;
  }

  // ── NO CODE: add in place so the drawer opens and they carry on reading ──
  const originalLabel = btn.innerText;
  btn.disabled = true;
  btn.innerText = 'Adding…';
  note.innerText = '';

  const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

  fetch(`${addUrl}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ items }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) throw new Error(data.description || 'Could not add the bundle');

      document.dispatchEvent(
        new CustomEvent('updatecart', { detail: { variant_id: items[0].id } })
      );

      trackAddToCart('Added Quiz Bundle to Cart', bundleProducts, bundleTracking);

      btn.innerText = 'Added to cart ✓';
      note.innerHTML = `<a href="${cartUrl}">View cart ➔</a>`;
    })
    .catch((error) => {
      console.error('Bundle add to cart error:', error);
      btn.disabled = false;
      btn.innerText = originalLabel;
      note.innerText = "Couldn't add the bundle — please try again.";
    });
}

function renderResearch(res) {
  let html = '';

  if (res.research) {
    html += `<div class="research-section">
          <h3>The Science Behind This Stage</h3>
          <p>"${res.research}"</p>
        </div>`;
  }

  if (res.resource && res.resource.url) {
    html += `
      <div class="resource-section">
        <h3>Free Resource for Parents</h3>
        <p><strong>${res.resource.title}</strong> — ${res.resource.desc}</p>
        <a href="${res.resource.url}" target="_blank" class="resource-btn">Download Free PDF ➔</a>
      </div>`;
  }

  // Pair them side by side on desktop instead of stacking two near-empty cards
  return html ? `<div class="insights-grid">${html}</div>` : '';
}

function renderNextLayer(res) {
  if (!layers.find((x) => x.id === res.nextLayerId)) return '';

  const nextL = layers.find((x) => x.id === res.nextLayerId);

  return `
        <div class="next-layer-section" style="background-color: ${
          nextL.color
        }15; border: 2px solid ${nextL.color}30;">
          <div class="next-layer-label" style="color: ${nextL.color}">What Comes Next</div>
          <div class="next-layer-title">${nextL.name}</div>
          <div class="next-layer-desc">${res.nextDesc}</div>
          <div class="next-layer-products">
            ${res.nextProducts
              .map(
                (p) =>
                  `<div class="next-layer-product-pill" style="color: ${nextL.color}; border-color: ${nextL.color}40">${p}</div>`
              )
              .join('')}
          </div>
          <button class="save-path-btn" id="save-path-btn" onclick="savePath()" style="background-color: ${
            nextL.color
          }; color: #fff; border: none; font-weight: 800; margin-top: 24px;">Save my child's path — remind me when they're ready ➔</button>
        </div>
      `;
}

// ── KLAVIYO TRACKING ──────────────────────────────────────────────────────
// Everything Klaviyo-facing goes through these helpers. They never throw and never
// reject, so an ad-blocker, a disabled app embed or a slow network can't take the
// quiz UI down with them — they just resolve false and log.

function klaviyoReady() {
  return typeof window !== 'undefined' && !!window.klaviyo;
}

function klaviyoCall(method, ...args) {
  if (!klaviyoReady()) {
    console.warn(`Klaviyo unavailable — "${method}" not sent.`);
    return Promise.resolve(false);
  }

  try {
    return Promise.resolve(window.klaviyo[method](...args))
      .then(() => true)
      .catch((error) => {
        console.error(`Klaviyo ${method} error:`, error);
        return false;
      });
  } catch (error) {
    console.error(`Klaviyo ${method} error:`, error);
    return Promise.resolve(false);
  }
}

function klaviyoIdentify(email, properties) {
  if (!email) return Promise.resolve(false);
  return klaviyoCall('identify', { email, ...properties });
}

function klaviyoTrack(metric, properties) {
  return klaviyoCall('track', metric, properties);
}

// Analytics never holds the parent hostage — cap how long the UI waits on it.
function settleWithin(promise, ms) {
  return Promise.race([
    promise,
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    }),
  ]);
}

// Klaviyo email templates can't resolve protocol-relative or root-relative paths.
function absoluteUrl(url) {
  if (!url) return '';
  if (url.startsWith('//')) return `https:${url}`;
  if (/^https?:\/\//i.test(url)) return url;
  return `${window.location.origin}${url.startsWith('/') ? '' : '/'}${url}`;
}

function toAmount(cents) {
  return typeof cents === 'number' ? cents / 100 : 0;
}

function currencyCode() {
  return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
}

function layerName(layerId) {
  const layer = layers.find((l) => l.id === layerId);
  return layer ? layer.name : '';
}

// Full objects, not just names — a flow email has to be able to render the
// recommendation cards (image, price, link) without calling back to Shopify.
function productPayload(p) {
  return {
    name: p.name,
    url: absoluteUrl(p.url),
    image: absoluteUrl(p.image),
    price: p.price,
    value: toAmount(p.priceCents),
    variant_id: p.variantId,
  };
}

// Shared payload for every quiz metric, so a flow triggered by any of them has the
// same context — including what comes next, which used to live only on the
// save-path event and so was invisible for anyone who didn't click that button.
function quizContext(outcomeId) {
  const res = results[outcomeId] || {};
  const products = res.products || [];

  return {
    quiz_name: quizSettings.quizName,
    ...userState,
    charged_layers: chargedLayerIds
      .map((idx) => (layers[idx] ? layers[idx].name : ''))
      .filter(Boolean),
    outcome_id: outcomeId,
    stage: res.stage || '',
    charging_layer: layerName(res.chargingLayerId),
    charging_layer_id: res.chargingLayerId,
    next_layer: layerName(res.nextLayerId),
    next_layer_id: res.nextLayerId,
    next_layer_products: res.nextProducts || [],
    next_quiz: quizSettings.nextQuizName || '',
    next_quiz_url: absoluteUrl(quizSettings.nextQuizUrl),
    resource_title: (res.resource && res.resource.title) || '',
    resource_url: absoluteUrl(res.resource && res.resource.url),
    recommended_products: products.map(productPayload),
    recommended_product_names: products.map((p) => p.name),
    bundle_total: res.bundle ? res.bundle.total : '',
    bundle_price: res.bundle ? res.bundle.price : '',
    bundle_savings: res.bundle ? res.bundle.savings : '',
    currency: currencyCode(),
  };
}

// Mirrored onto the profile so segmentation ("parents of a 5-7 year old", "still
// charging Phonics") doesn't have to be rebuilt from event history every time.
function profileProperties(context) {
  const props = {
    literacy_quiz_name: context.quiz_name,
    literacy_quiz_completed_at: new Date().toISOString(),
    literacy_outcome_id: context.outcome_id,
    literacy_stage: context.stage,
    literacy_charging_layer: context.charging_layer,
    literacy_next_layer: context.next_layer,
    literacy_charged_layers: context.charged_layers,
  };

  Object.keys(userState).forEach((key) => {
    if (key === 'charged_layers') return; // already on there as names
    props[`literacy_${key}`] = userState[key];
  });

  return props;
}

// Proof of what the parent ticked, alongside the list subscribe itself.
function consentProperties() {
  return {
    literacy_marketing_consent: true,
    literacy_consent_version: quizSettings.consentVersion || '',
    literacy_consent_source: 'Literacy quiz email gate',
    literacy_consent_at: new Date().toISOString(),
  };
}

// The theme-wide helper hits the same endpoint but keeps one code path — and it
// hands back the parsed body, which the old inline fetch threw away. Klaviyo
// answers 200 with { success: false, errors: [...] }, so a rejected signup used to
// look identical to a successful one.
function subscribeToQuizList(email) {
  const listId = (quizSettings.klaviyoListId || '').trim();
  if (!listId) return Promise.resolve(false);

  let request;
  if (window.bitcube && window.bitcube.subscribeToList) {
    request = window.bitcube.subscribeToList(listId, email);
  } else {
    const formData = new FormData();
    formData.append('g', listId);
    formData.append('email', email);
    request = fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      body: formData,
    }).then((response) => response.json());
  }

  return Promise.resolve(request)
    .then((data) => {
      if (data && data.success === false) {
        console.error('Klaviyo list subscribe rejected:', data.errors || data);
        return false;
      }
      return true;
    })
    .catch((error) => {
      console.error('Klaviyo list subscribe error:', error);
      return false;
    });
}

// Cart-level tracking can't know which outcome, layer or bundle drove the add, so
// the quiz fires its own events with that context attached.
function addToCartPayload(items, extra) {
  return {
    ...quizContext(currentOutcomeId),
    added_products: items.map(productPayload),
    added_product_names: items.map((p) => p.name),
    item_count: items.length,
    $value: items.reduce((sum, p) => sum + toAmount(p.priceCents), 0),
    ...extra,
  };
}

function trackAddToCart(metric, items, extra) {
  return klaviyoTrack(metric, addToCartPayload(items, extra));
}

// Klaviyo's client API needs a revision pin. Bump it deliberately, not incidentally.
const KLAVIYO_API_REVISION = '2024-10-15';

// Used only when the click navigates away (the bundle permalink). `keepalive` lets the
// request outlive the page; an in-flight klaviyo.track() would just be cancelled by the
// navigation. Needs an explicit profile because it doesn't go through the onsite JS, so
// it reports whether it could actually fire and the caller falls back if not.
function klaviyoBeacon(metric, properties, email, value) {
  const companyId = (quizSettings.klaviyoCompanyId || '').trim();
  if (!companyId || !email) return false;

  try {
    fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_API_REVISION,
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties,
            value,
            metric: { data: { type: 'metric', attributes: { name: metric } } },
            profile: { data: { type: 'profile', attributes: { email } } },
          },
        },
      }),
    }).catch((error) => {
      console.error('Klaviyo beacon error:', error);
    });
    return true;
  } catch (error) {
    console.error('Klaviyo beacon error:', error);
    return false;
  }
}

// Cart permalinks apply the discount in the same hop as the items, so the code can't
// linger on the session for a later single-product add, and land the parent straight in
// checkout. The trade is that they REPLACE the cart rather than adding to it.
function bundlePermalinkUrl(items, code) {
  const root = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
  const line = items.map((p) => `${p.variantId}:1`).join(',');

  return `${root}/cart/${line}${code ? `?discount=${encodeURIComponent(code)}` : ''}`;
}

// The product card buttons are added to cart by the theme-wide `.ajax_cart` listener
// in global.js, which fires the Reddit pixel and nothing else. We listen alongside it
// rather than reimplementing the add.
document.addEventListener('click', (event) => {
  const page = document.getElementById('results-page');
  if (!page || !event.target || !event.target.closest) return;

  const btn = event.target.closest('.product-card-btn');
  if (!btn || !page.contains(btn)) return;

  const res = results[currentOutcomeId];
  const variantId = btn.dataset.variant_id;
  const product = (res && res.products ? res.products : []).find(
    (p) => String(p.variantId) === String(variantId)
  );
  if (!product) return;

  trackAddToCart('Added Quiz Product to Cart', [product]);
});

// Sends the finished path to Klaviyo against the email captured at the gate, so a flow can
// nudge the parent when the next layer is due.
function savePath() {
  const btn = document.getElementById('save-path-btn');
  if (!btn || btn.disabled) return;

  btn.disabled = true;
  btn.innerText = 'Saving…';

  const done = (saved) => {
    btn.classList.add('saved');
    // Only promise the follow-up when something actually recorded it.
    btn.innerText = saved ? "Saved ✓ — we'll email you when they're ready" : 'Saved ✓';
  };

  if (!klaviyoReady() || !userEmail) {
    // Ad-blocker or a page reload straight into results — still give the parent a clear answer
    console.warn('Klaviyo unavailable or no email captured; path not saved remotely.');
    done(false);
    return;
  }

  klaviyoIdentify(userEmail)
    .then(() =>
      klaviyoTrack('Saved Literacy Path', {
        ...quizContext(currentOutcomeId),
        saved_path: true,
      })
    )
    .then(done);
}

// The opt-in now lives inside the results, between the bundle and the insights grid,
// so results are never withheld behind an email.
function renderEmailCapture() {
  return `
        <div class="email-capture" id="email-capture">
          <div class="email-capture__icon">\u26a1</div>
          <h3>Keep your child's full literacy path</h3>
          <p>Pop your email in and we'll send you a copy of these results \u2014 plus their full literacy path to keep.</p>
          <input class="email-input" type="email" id="email-input" placeholder="Your email address">
          <label class="email-capture__consent" for="marketing-consent">
            <input type="checkbox" id="marketing-consent">
            <span>I agree to receive marketing emails, newsletter updates, and my child's free PDF path.</span>
          </label>
          <button class="email-submit" onclick="submitQuizEmail()">Send Me My Child's Path \u279c</button>
          <div class="email-capture__error" id="email-error">Please provide a valid email and check the consent box.</div>
          <p class="email-capture__note">No spam. Just your child's path.</p>
        </div>`;
}

function submitQuizEmail() {
  const emailInput = document.getElementById('email-input').value;
  const consentChecked = document.getElementById('marketing-consent').checked;
  const errorEl = document.getElementById('email-error');

  // 1. Basic validation
  if (!emailInput || !emailInput.includes('@') || !consentChecked) {
    errorEl.style.display = 'block';
    return;
  }

  errorEl.style.display = 'none';

  // Keep the address around so the save-path button can identify against it later
  userEmail = emailInput;

  const submitBtn = document.querySelector('#email-capture .email-submit');
  submitBtn.innerText = 'Sending...';
  submitBtn.disabled = true;

  const outcomeId = currentOutcomeId || resolveOutcomeId();
  const context = quizContext(outcomeId);

  // The metric and the list signup run side by side. They used to be chained, so a
  // blocked subscribe request took the submission event down with it \u2014 the one event
  // every downstream flow is triggered by.
  const tracked = klaviyoIdentify(emailInput, {
    ...profileProperties(context),
    ...consentProperties(),
  }).then(() => klaviyoTrack('Completed Literacy Quiz', context));

  const subscribed = subscribeToQuizList(emailInput);

  // Always confirm, even if an ad-blocker disrupts either request
  settleWithin(Promise.all([tracked, subscribed]), 1500).then(() => {
    const card = document.getElementById('email-capture');
    if (!card) return;
    card.classList.add('email-capture--done');
    card.innerHTML =
      '<div class="email-capture__icon">\u2705</div>' +
      "<h3>Check your inbox.</h3>" +
      '<p class="email-capture__note"></p>';
    // textContent, not innerHTML \u2014 the address is user input
    card.querySelector('.email-capture__note').textContent =
      "We've sent your child's full literacy path to " + emailInput + '.';
  });
}
